import { render } from "./IconTelegram.vue?vue&type=template&id=fc561e20&scoped=true&ts=true"
import script from "./IconTelegram.vue?vue&type=script&lang=ts"
export * from "./IconTelegram.vue?vue&type=script&lang=ts"

import "./IconTelegram.vue?vue&type=style&index=0&id=fc561e20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc561e20"]])

export default __exports__